import { Component, OnDestroy, OnInit } from '@angular/core';
import { DodajTransakcijuManuelnoCommand, IDodajTransakcijuManuelnoCommand, ISifraPlacanjaDto, IStrankaRacunaDto, IzvodiClient, SifraPlacanjaDto, StrankaClient, StrankaDto, StrankaRacunaDto } from '@kodit/core/data-api';
import { Validators } from '@angular/forms';
import { FormGroupTypeSafe } from 'angular-typesafe-reactive-forms-helper';
import { Subscription } from 'rxjs';
import { IzvodiService } from '../izvodi.service';
import { DynamicDialogConfig, DynamicDialogRef } from '@kodit/core/shared-ui';
import { FormHelper } from '@kodit/core/form-definitions';
import { AlertService, ButtonService, SharedService } from '@kodit/core/services';
import { DialogSize } from 'libs/core/shared-ui/src/lib/dialogs/dynamic-dialog/dynamicdialog-config';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'kodit-unos-transakcije-form',
  templateUrl: './unos-transakcije-form.component.html',
  styleUrls: ['./unos-transakcije-form.component.scss']
})
export class UnosTransakcijeFormComponent implements OnInit, OnDestroy{

  form!: FormGroupTypeSafe<IDodajTransakcijuManuelnoCommand>;

  isSearchClicked = false;
  showMessage = false;
  jeDevizni = false;
  drugaStranaNazivLabel = '';

  private _subs: Subscription = new Subscription();

  constructor(
    private _service: IzvodiService,
    private _dialogRef: DynamicDialogRef,
    private _formHelper: FormHelper,
    private _btnService: ButtonService,
    private _sharedService: SharedService,
    private _client: IzvodiClient,
    private _alertService: AlertService,
    public _dialogConfig: DynamicDialogConfig,
    public _strankaCLient: StrankaClient
  ) { }

  ngOnInit(): void {
    this.form = this._service.getTransakcijaForm();

    this.form.controls.smerKnjizenja.setValue(this._dialogConfig.data.smerKnjizenja);
    this.form.controls.smerKnjizenja.updateValueAndValidity();
    this.form.controls.izvodId.setValue(this._dialogConfig.data.izvodId);
    this.form.controls.izvodId.updateValueAndValidity();

    this.jeDevizni = !!this._dialogConfig.data.jeDevizni;
    if (this.jeDevizni) {
      this.form.controls.pozivNaBroj.clearValidators();
      this.form.controls.pozivNaBroj.updateValueAndValidity();

      this.form.controls.swift.setValidators([Validators.required]);
      this.form.controls.swift.updateValueAndValidity();

      this.form.controls.svrhaPlacanja.clearValidators();
      this.form.controls.svrhaPlacanja.updateValueAndValidity();

      this.drugaStranaNazivLabel =
        this._dialogConfig.data.smerKnjizenja === 'zaduženje'
          ? 'Primalac'
          : 'Platilac';
    }

    this._subs.add(
      this._dialogRef.onSubmit.subscribe(() => {
        this.save();
      })
    );
  }

  private save() {

    if (!this.form.valid) {
      this._formHelper.invalidateForm(this.form);
      return;
    }

    this._btnService.disableButton();

    this._sharedService.displayLoadingScreen(true, "Unos transakcije");
    this._subs.add(
      this._client
        .dodajTransakcijuManuelno(
          this.form.value as DodajTransakcijuManuelnoCommand
        )
        .pipe(
          finalize(() => {
            this._sharedService.resetLoadingScreen();
          })
        )
        .subscribe((res) => {
          this._alertService.addSuccessMsg(
             res.messages[0]
            );
            this._dialogRef.close(res.data);
        })
      );
  }

  getStranka(){
    this._sharedService.displayLoadingScreen(true, "Pronalaženje stranke");
    this._subs.add(
      this._strankaCLient
        .getStrankaOdTekucegRacuna(this.form.controls.drugaStranaRacun.value)
        .pipe(
          finalize(() => {
            this._sharedService.resetLoadingScreen();
          })
        )
        .subscribe(
          (res) => {
            if(res.succeeded){
              this.form.controls.drugaStrana.setValue(res.data);
              this.form.controls.drugaStranaNaziv.setValue(res.data.naziv);
              this.form.controls.smerKnjizenja.updateValueAndValidity();
              this.showMessage = false;
              this.isSearchClicked = false;
            }else{
              this.showMessage = true;
              this.form.controls.drugaStranaNaziv.reset();
              this.form.controls.drugaStrana.reset();
              this.isSearchClicked = true;
              this._alertService.addWarnMsg(res.messages[0]);
            }
          }
        )
    );
  }


  onKeyReleased(value: string): void {
    this.form.controls.drugaStranaNaziv.reset();
  }

  onSifrePlacanjaChanged(sifraPlacanja: ISifraPlacanjaDto) {
    this.form.controls.svrhaPlacanja.setValue(sifraPlacanja.opis);
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

}
